import { useDispatch, useSelector } from "react-redux";
import { FieldPanel, FieldComponent as Field, SelectComponent, NumberRange } from "shared/ui-kit";

import { ScreenerStore, ScreenerStoreFilter, ScreenerStoreFilterNumberRangeInput, ScreenerStoreFilterSelectInput } from "../redux/model";
import { filterInputSetNumberRangeFieldValue, filterInputSetSelectFieldValue } from "../redux/actions";
import { SelectFieldConfiguration, NumberRangeFieldConfiguration, KnownFields, FieldConfiguration } from "../fields";

import styles from './ScreenerSettingsContentComponent.module.scss';

export const ScreenerSettingsContentComponent = () => {
	const filter = useSelector<ScreenerStore, ScreenerStoreFilter>(x => x.filter);

	return (
		<div className={styles.panels}>
			<FieldPanel title="Основные фильтры" defaults={{ isExpanded: true }} badge={badge(filter, KnownFields.assetClass, KnownFields.assetSubClass, KnownFields.region, KnownFields.region, KnownFields.marketType, KnownFields.issuer)}>
				<div className={styles.items}>
					<SelectField configuration={KnownFields.assetClass} />
					<SelectField configuration={KnownFields.assetSubClass} />
					<SelectField configuration={KnownFields.region} />
					<SelectField configuration={KnownFields.county} />
					<SelectField configuration={KnownFields.marketType} />
					<SelectField configuration={KnownFields.issuer} />
					<SelectField configuration={KnownFields.tradingStatus} />
				</div>
			</FieldPanel>
			<FieldPanel title="Доходность" defaults={{ isExpanded: false }} badge={badge(filter, KnownFields.return1Day, KnownFields.return1Week, KnownFields.return1Month, KnownFields.return3Months, KnownFields.return1Year)}>
				<div className={styles.items}>
					<NumberRangeField configuration={KnownFields.return1Day} />
					<NumberRangeField configuration={KnownFields.return1Week} />
					<NumberRangeField configuration={KnownFields.return1Month} />
					<NumberRangeField configuration={KnownFields.return3Months} />
					<NumberRangeField configuration={KnownFields.return1Year} />
				</div>
			</FieldPanel>
			<FieldPanel title="Состав" defaults={{ isExpanded: false }} badge={badge(filter, KnownFields.structureTotal, KnownFields.structureTop3Percent, KnownFields.structureTop5Percent, KnownFields.structureTop10Percent, KnownFields.structureTop50Percent)}>
				<div className={styles.items}>
					<NumberRangeField configuration={KnownFields.structureTotal} />
					<NumberRangeField configuration={KnownFields.structureTop3Percent} />
					<NumberRangeField configuration={KnownFields.structureTop5Percent} />
					<NumberRangeField configuration={KnownFields.structureTop10Percent} />
					<NumberRangeField configuration={KnownFields.structureTop50Percent} />
				</div>
			</FieldPanel>
			<FieldPanel title="Комиссия и СЧА" defaults={{ isExpanded: false }} badge={badge(filter, KnownFields.assetsUnderManagement, KnownFields.commisionPercent, KnownFields.currency, KnownFields.dividendPolicy)}>
				<div className={styles.items}>
					<NumberRangeField configuration={KnownFields.assetsUnderManagement} />
					<NumberRangeField configuration={KnownFields.commisionPercent} />
					<SelectField configuration={KnownFields.currency} />
					<SelectField configuration={KnownFields.dividendPolicy} />
				</div>
			</FieldPanel>
			<FieldPanel title="Риск" defaults={{ isExpanded: false }} badge={badge(filter, KnownFields.sharpe, KnownFields.sortino, KnownFields.var5Percent)}>
				<div className={styles.items}>
					<NumberRangeField configuration={KnownFields.sharpe} />
					<NumberRangeField configuration={KnownFields.sortino} />
					<NumberRangeField configuration={KnownFields.var5Percent} />
				</div>
			</FieldPanel>
		</div>
	);
};

function badge(filter: ScreenerStoreFilter, ...fields: FieldConfiguration[]): string {
	const selectedFiltersCount = fields.filter(field => field.hasSelectedValue(filter)).length;
	if (selectedFiltersCount === 0)
		return '';

	return selectedFiltersCount.toLocaleString();
}

interface SelectFieldProps {
	configuration: SelectFieldConfiguration;
}
const SelectField = (props: SelectFieldProps) => {
	const filter = useSelector<ScreenerStore, ScreenerStoreFilter>(x => x.filter);
	const dispatch = useDispatch();

	const { systemName } = props.configuration;
	const input = filter.inputs[systemName] as ScreenerStoreFilterSelectInput;
	if (input === undefined) {
		console.error(`field ${systemName} not found`);
		return null;
	}

	return (
		<Field title={props.configuration.title}>
			<SelectComponent
				items={input.items}
				selectedKey={input.selectedKey}
				onSelectedItemChanged={item => dispatch(filterInputSetSelectFieldValue({ systemName, value: item.key })) } />
		</Field>
	);
}


interface NumberRangeFieldProps {
	configuration: NumberRangeFieldConfiguration;
}
const NumberRangeField = (props: NumberRangeFieldProps) => {
	const filter = useSelector<ScreenerStore, ScreenerStoreFilter>(x => x.filter);
	const dispatch = useDispatch();

	const { systemName, formatter } = props.configuration;
	const input = filter.inputs[systemName] as ScreenerStoreFilterNumberRangeInput;
	if (input === undefined) {
		console.error(`field ${systemName} not found`);
		return null;
	}

	return (
		<Field title={props.configuration.title}>
			<NumberRange
				range={input.restriction}
				value={input.value}
				formatter={formatter}
				onSelectedRangeChange={newRange => dispatch(filterInputSetNumberRangeFieldValue({ systemName, value: newRange }))} />
		</Field>
	);
}
